"use strict";

define('model/message.template',['./base', 'datakit/util/url', 'datakit/model.registry'], function (Base, url, ModelRegistry) {
  var URL_BY_CODE = '/rs/api/messageTemplate/:code.name/:templateType.name';
  var URL_PREVIEW = '/rs/api/messageTemplate/preview/:id';
  var URL_PREVIEW_BY_OWNER = URL_PREVIEW + '/:ownerId';
  var MessageTemplate = Base.extend({
    urlRoot: '/rs/api/messageTemplate',
    childModels: {
      'templateType': 'TemplateType',
      'code': 'MessageCode'
    },
    virtual: {
      'original': {
        deps: ['override'],
        get: function get() {
          return !this.get('override');
        }
      }
    },
    defaults: {
      'cc': '',
      'bcc': '',
      'content': ''
    },
    isEmail: function isEmail() {
      return this.get('templateType.name') === 'Email';
    },
    isSendable: function isSendable() {
      return !!this.get('code.sendable');
    },
    isRichText: function isRichText() {
      return String(this.get('contentType')).indexOf('html') >= 0;
    },
    fetch: function fetch(options) {
      var options = options || {};
      if (!this.has(this.idAttribute) || options.revert == true) {
        options.url = url.template(URL_BY_CODE, this);
        delete options.revert;
      }
      return Base.prototype.fetch.call(this, options);
    },
    toEmailMessage: function toEmailMessage() {
      var EmailMessage = ModelRegistry.get('EmailMessage');
      return new EmailMessage(this.pick('content', 'recipients', 'cc', 'bcc', 'subject'));
    },
    preview: function preview(options) {
      options = options || {};
      var ownerId = options.ownerId,
        email = options.email || this.toEmailMessage(),
        self = this;
      return email.save({}, {
        type: 'POST',
        success: function success() {
          self.trigger('preview', email);
        },
        url: ownerId == null ? url.template(URL_PREVIEW, this) : url.template(URL_PREVIEW_BY_OWNER, {
          ownerId: ownerId
        }, this)
      });
    }
  });
  return MessageTemplate;
});

